<template>
  <div class="dashboard">
    <div class="row">
      <div class="col-md-6 col-xl-4">
        <div class="card mb-3 widget-content">
          <div class="widget-content-outer">
            <div class="widget-content-wrapper">
              <div class="widget-content-left">
                <div class="widget-heading">Total Orders</div>
                <div class="widget-subheading">Last year expenses</div>
              </div>
              <div class="widget-content-right">
                <div class="widget-numbers text-success">1896</div>
              </div>
            </div>
            <div class="widget-progress-wrapper">
              <div class="progress-bar-sm progress">
                <div
                  class="progress-bar bg-primary"
                  role="progressbar"
                  aria-valuenow="71"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 71%;"
                ></div>
              </div>
              <div class="progress-sub-label">
                <div class="sub-label-left">YoY Growth</div>
                <div class="sub-label-right">100%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-4">
        <div class="card mb-3 widget-content">
          <div class="widget-content-outer">
            <div class="widget-content-wrapper">
              <div class="widget-content-left">
                <div class="widget-heading">Products Sold</div>
                <div class="widget-subheading">Revenue streams</div>
              </div>
              <div class="widget-content-right">
                <div class="widget-numbers text-warning">$3M</div>
              </div>
            </div>
            <div class="widget-progress-wrapper">
              <div class="progress-bar-sm progress-bar-animated-alt progress">
                <div
                  class="progress-bar bg-danger"
                  role="progressbar"
                  aria-valuenow="85"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 85%;"
                ></div>
              </div>
              <div class="progress-sub-label">
                <div class="sub-label-left">Sales</div>
                <div class="sub-label-right">100%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-4">
        <div class="card mb-3 widget-content">
          <div class="widget-content-outer">
            <div class="widget-content-wrapper">
              <div class="widget-content-left">
                <div class="widget-heading">Followers</div>
                <div class="widget-subheading">People Interested</div>
              </div>
              <div class="widget-content-right">
                <div class="widget-numbers text-danger">45,9%</div>
              </div>
            </div>
            <div class="widget-progress-wrapper">
              <div class="progress-bar-sm progress-bar-animated-alt progress">
                <div
                  class="progress-bar bg-success"
                  role="progressbar"
                  aria-valuenow="46"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 46%;"
                ></div>
              </div>
              <div class="progress-sub-label">
                <div class="sub-label-left">Twitter Progress</div>
                <div class="sub-label-right">100%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-xl-none d-lg-block col-md-6 col-xl-4">
        <div class="card mb-3 widget-content">
          <div class="widget-content-outer">
            <div class="widget-content-wrapper">
              <div class="widget-content-left">
                <div class="widget-heading">Income</div>
                <div class="widget-subheading">Expected totals</div>
              </div>
              <div class="widget-content-right">
                <div class="widget-numbers text-focus">$147</div>
              </div>
            </div>
            <div class="widget-progress-wrapper">
              <div class="progress-bar-sm progress-bar-animated-alt progress">
                <div
                  class="progress-bar bg-info"
                  role="progressbar"
                  aria-valuenow="54"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 54%;"
                ></div>
              </div>
              <div class="progress-sub-label">
                <div class="sub-label-left">Expenses</div>
                <div class="sub-label-right">100%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-xl-6">
        <div class="row">
          <div class="col-md-6 col-lg-3 col-xl-6">
            <div
              class="card mb-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-success border-success"
            >
              <div class="widget-chat-wrapper-outer">
                <div class="widget-chart-content pt-3 pl-3 pb-1">
                  <div class="widget-chart-flex">
                    <div class="widget-numbers">
                      <div class="widget-chart-flex">
                        <div class="fsize-4">
                          <small class="opacity-5">$</small>
                          <span>874</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 class="widget-subheading mb-0 opacity-5">sales last month</h6>
                </div>
                <div class="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto row">
                  <div class="col-md-9">
                    <div id="dashboard-sparklines-1"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 col-xl-6">
            <div
              class="card mb-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-primary border-primary"
            >
              <div class="widget-chat-wrapper-outer">
                <div class="widget-chart-content pt-3 pl-3 pb-1">
                  <div class="widget-chart-flex">
                    <div class="widget-numbers">
                      <div class="widget-chart-flex">
                        <div class="fsize-4">
                          <small class="opacity-5">$</small>
                          <span>1283</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 class="widget-subheading mb-0 opacity-5">sales Income</h6>
                </div>
                <div class="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto row">
                  <div class="col-md-9">
                    <div id="dashboard-sparklines-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 col-xl-6">
            <div
              class="card mb-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-warning border-warning"
            >
              <div class="widget-chat-wrapper-outer">
                <div class="widget-chart-content pt-3 pl-3 pb-1">
                  <div class="widget-chart-flex">
                    <div class="widget-numbers">
                      <div class="widget-chart-flex">
                        <div class="fsize-4">
                          <small class="opacity-5">$</small>
                          <span>1286</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 class="widget-subheading mb-0 opacity-5">last month sales</h6>
                </div>
                <div class="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto row">
                  <div class="col-md-9">
                    <div id="dashboard-sparklines-3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 col-xl-6">
            <div
              class="card mb-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger border-danger"
            >
              <div class="widget-chat-wrapper-outer">
                <div class="widget-chart-content pt-3 pl-3 pb-1">
                  <div class="widget-chart-flex">
                    <div class="widget-numbers">
                      <div class="widget-chart-flex">
                        <div class="fsize-4">
                          <small class="opacity-5">$</small>
                          <span>564</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h6 class="widget-subheading mb-0 opacity-5">total revenue</h6>
                </div>
                <div class="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto row">
                  <div class="col-md-9">
                    <div id="dashboard-sparklines-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-6">
        <div class="mb-3 card">
          <div class="card-header-tab card-header">
            <div class="card-header-title">
              <i class="header-icon lnr-rocket icon-gradient bg-tempting-azure"></i>
              Bandwidth Reports
            </div>
            <div class="btn-actions-pane-right text-capitalize">
              <button class="btn-wide btn-outline-2x btn btn-outline-primary btn-sm">View All</button>
            </div>
          </div>
          <div class="pt-2 pb-0 card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="widget-content mt-2">
                  <div class="widget-content-outer">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left pr-2 fsize-1">
                        <div class="widget-numbers fsize-3 text-alternate">61%</div>
                      </div>
                      <div class="widget-content-right w-100">
                        <div class="progress-bar-xs progress">
                          <div
                            class="progress-bar bg-alternate"
                            role="progressbar"
                            aria-valuenow="71"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style="width: 71%;"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="widget-content-left fsize-1">
                      <div class="text-muted opacity-6">Server Target</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="widget-content mt-2">
                  <div class="widget-content-outer">
                    <div class="widget-content-wrapper">
                      <div class="widget-content-left pr-2 fsize-1">
                        <div class="widget-numbers fsize-3 text-danger">71%</div>
                      </div>
                      <div class="widget-content-right w-100">
                        <div class="progress-bar-xs progress">
                          <div
                            class="progress-bar bg-danger"
                            role="progressbar"
                            aria-valuenow="71"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style="width: 71%;"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="widget-content-left fsize-1">
                      <div class="text-muted opacity-6">Income Target</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="widget-chart p-0">
            <div id="dashboard-sparklines-primary"></div>
          </div>
          <div class="divider mb-0"></div>
          <div class="grid-menu grid-menu-2col">
            <div class="no-gutters row">
              <div class="p-2 col-sm-6">
                <button
                  class="btn-icon-vertical btn-transition-text btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-success"
                >
                  <i class="lnr-lighter text-success opacity-7 btn-icon-wrapper mb-2"></i>
                  Accounts
                </button>
              </div>
              <div class="p-2 col-sm-6">
                <button
                  class="btn-icon-vertical btn-transition-text btn-transition btn-transition-alt pt-2 pb-2 btn btn-outline-alternate"
                >
                  <i class="lnr-gift text-alternate opacity-7 btn-icon-wrapper mb-2"></i>
                  Services
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-xl-4">
        <div class="mb-3 card">
          <div class="card-header-tab card-header">
            <div class="card-header-title font-size-lg text-capitalize font-weight-normal">
              <i class="header-icon lnr-shirt mr-3 text-muted opacity-6"></i>
              Top Sellers
            </div>
            <div class="btn-actions-pane-right actions-icon-btn">
              <div class="btn-group dropdown">
                <button
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  class="btn-icon btn-icon-only btn btn-link"
                >
                  <i class="pe-7s-menu btn-icon-wrapper"></i>
                </button>
                <div
                  tabindex="-1"
                  role="menu"
                  aria-hidden="true"
                  class="dropdown-menu-shadow dropdown-menu-hover-link dropdown-menu"
                >
                  <h6 tabindex="-1" class="dropdown-header">Header</h6>
                  <button type="button" tabindex="0" class="dropdown-item">
                    <i class="dropdown-icon lnr-inbox"></i>
                    <span>Menus</span>
                  </button>
                  <button type="button" tabindex="0" class="dropdown-item">
                    <i class="dropdown-icon lnr-file-empty"></i>
                    <span>Settings</span>
                  </button>
                  <button type="button" tabindex="0" class="dropdown-item">
                    <i class="dropdown-icon lnr-book"></i>
                    <span>Actions</span>
                  </button>
                  <div tabindex="-1" class="dropdown-divider"></div>
                  <div class="p-1 text-right">
                    <button class="mr-2 btn-shadow btn-sm btn btn-link">View Details</button>
                    <button class="mr-2 btn-shadow btn-sm btn btn-primary">Action</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="widget-chart widget-chart2 text-left p-0">
            <div class="widget-chat-wrapper-outer">
              <div class="widget-chart-content widget-chart-content-lg">
                <div class="widget-chart-flex">
                  <div
                    class="widget-title opacity-5 text-muted text-uppercase"
                  >New accounts since 2018</div>
                </div>
                <div class="widget-numbers">
                  <div class="widget-chart-flex">
                    <div>
                      <span class="opacity-10 text-success pr-2">
                        <i class="fa fa-angle-up"></i>
                      </span>
                      <span>9</span>
                      <small class="opacity-5 pl-1">%</small>
                    </div>
                    <div class="widget-title ml-2 font-size-lg font-weight-normal text-muted">
                      <span class="text-danger pl-2">+14% failed</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="widget-chart-wrapper widget-chart-wrapper-xlg opacity-10 m-0">
                <div id="dashboard-sparkline-3" style="min-height: 152px;">
                  <div
                    id="apexchartsqhqchkth"
                    class="apexcharts-canvas apexchartsqhqchkth"
                    style="width: 316px; height: 152px;"
                  >
                    <svg
                      id="SvgjsSvg1038"
                      width="316"
                      height="152"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xmlns:svgjs="http://svgjs.com/svgjs"
                      class="apexcharts-svg"
                      xmlns:data="ApexChartsNS"
                      transform="translate(0, 0)"
                      style="background: transparent;"
                    >
                      <g
                        id="SvgjsG1040"
                        class="apexcharts-inner apexcharts-graphical"
                        transform="translate(0, 0)"
                      >
                        <defs id="SvgjsDefs1039">
                          <clipPath id="gridRectMaskqhqchkth">
                            <rect
                              id="SvgjsRect1044"
                              width="321"
                              height="157"
                              x="-2.5"
                              y="-2.5"
                              rx="0"
                              ry="0"
                              fill="#ffffff"
                              opacity="1"
                              stroke-width="0"
                              stroke="none"
                              stroke-dasharray="0"
                            />
                          </clipPath>
                          <clipPath id="gridRectMarkerMaskqhqchkth">
                            <rect
                              id="SvgjsRect1045"
                              width="330"
                              height="166"
                              x="-7"
                              y="-7"
                              rx="0"
                              ry="0"
                              fill="#ffffff"
                              opacity="1"
                              stroke-width="0"
                              stroke="none"
                              stroke-dasharray="0"
                            />
                          </clipPath>
                          <linearGradient id="SvgjsLinearGradient1052" x1="0" y1="0" x2="0" y2="1">
                            <stop
                              id="SvgjsStop1053"
                              stop-opacity="0.7"
                              stop-color="rgba(58,196,125,0.7)"
                              offset="0"
                            />
                            <stop
                              id="SvgjsStop1054"
                              stop-opacity="0.9"
                              stop-color="rgba(255,255,255,0.9)"
                              offset="0.9"
                            />
                            <stop
                              id="SvgjsStop1055"
                              stop-opacity="0.9"
                              stop-color="rgba(255,255,255,0.9)"
                              offset="1"
                            />
                          </linearGradient>
                        </defs>
                        <rect
                          id="SvgjsRect1043"
                          width="1"
                          height="152"
                          x="0"
                          y="0"
                          rx="0"
                          ry="0"
                          fill="#b1b9c4"
                          opacity="1"
                          stroke-width="0"
                          stroke-dasharray="0"
                          class="apexcharts-xcrosshairs"
                          filter="none"
                          fill-opacity="0.9"
                        />
                        <g id="SvgjsG1057" class="apexcharts-xaxis" transform="translate(0, 0)">
                          <g
                            id="SvgjsG1058"
                            class="apexcharts-xaxis-texts-g"
                            transform="translate(0, 1.875)"
                          />
                        </g>
                        <g id="SvgjsG1061" class="apexcharts-grid">
                          <line
                            id="SvgjsLine1063"
                            x1="0"
                            y1="152"
                            x2="316"
                            y2="152"
                            stroke="transparent"
                            stroke-dasharray="0"
                          />
                          <line
                            id="SvgjsLine1062"
                            x1="0"
                            y1="1"
                            x2="0"
                            y2="152"
                            stroke="transparent"
                            stroke-dasharray="0"
                          />
                        </g>
                        <g id="SvgjsG1047" class="apexcharts-area-series apexcharts-plot-series">
                          <g
                            id="SvgjsG1048"
                            class="apexcharts-series series-1"
                            data-:longest-series="true"
                            rel="1"
                            data-:real-index="0"
                          >
                            <path
                              id="apexcharts-area-0"
                              d="M6.583333333333333 91.07502569373072C11.191666666666666 91.07502569373072 15.141666666666666 69.20452209660843 19.75 69.20452209660843C24.358333333333334 69.20452209660843 28.30833333333333 84.82631038026722 32.916666666666664 84.82631038026722C37.525 84.82631038026722 41.474999999999994 6.717368961973278 46.08333333333333 6.717368961973278C50.69166666666666 6.717368961973278 54.64166666666666 103.57245632065775 59.24999999999999 103.57245632065775C63.85833333333333 103.57245632065775 67.80833333333332 87.95066803699896 72.41666666666666 87.95066803699896C77.02499999999999 87.95066803699896 80.975 97.32374100719424 85.58333333333333 97.32374100719424C90.19166666666666 97.32374100719424 94.14166666666667 122.3186022610483 98.75 122.3186022610483C103.35833333333333 122.3186022610483 107.30833333333334 64.51798561151078 111.91666666666667 64.51798561151078C116.525 64.51798561151078 120.47500000000001 109.82117163412127 125.08333333333334 109.82117163412127C129.69166666666666 109.82117163412127 133.64166666666668 55.144912641315514 138.25 55.144912641315514C142.85833333333332 55.144912641315514 146.80833333333334 92.6372045220966 151.41666666666666 92.6372045220966C156.02499999999998 92.6372045220966 159.975 80.13977389516957 164.58333333333331 80.13977389516957C169.19166666666663 80.13977389516957 173.14166666666665 109.82117163412127 177.74999999999997 109.82117163412127C182.3583333333333 109.82117163412127 186.3083333333333 72.32887975334017 190.91666666666663 72.32887975334017C195.52499999999995 72.32887975334017 199.47499999999997 114.5077081192189 204.0833333333333 114.5077081192189C208.6916666666666 114.5077081192189 212.64166666666662 94.19938335046248 217.24999999999994 94.19938335046248C221.85833333333326 94.19938335046248 225.80833333333328 50.45837615621788 230.4166666666666 50.45837615621788C235.02499999999992 50.45837615621788 238.97499999999994 67.64234326824254 243.58333333333326 67.64234326824254C248.1916666666666 67.64234326824254 252.1416666666666 81.70195272353546 256.74999999999994 81.70195272353546C261.3583333333333 81.70195272353546 265.3083333333333 67.64234326824254 269.91666666666663 67.64234326824254C274.525 67.64234326824254 278.47499999999997 78.5775950668037 283.0833333333333 78.5775950668037C287.69166666666666 78.5775950668037 291.64166666666665 56.70709146968139 296.25 56.70709146968139C300.85833333333335 56.70709146968139 304.80833333333334 97.32374100719424 309.4166666666667 97.32374100719424C309.4166666666667 97.32374100719424 309.4166666666667 97.32374100719424 309.4166666666667 97.32374100719424 "
                              fill="none"
                              fill-opacity="1"
                              stroke="#3ac47d"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="5"
                              stroke-dasharray="0"
                              class="apexcharts-area"
                              index="0"
                              clip-path="url(#gridRectMaskqhqchkth)"
                              pathTo="M 6.583333333333333 91.07502569373072C 11.191666666666666 91.07502569373072 15.141666666666666 69.20452209660843 19.75 69.20452209660843C 24.358333333333334 69.20452209660843 28.30833333333333 84.82631038026722 32.916666666666664 84.82631038026722C 37.525 84.82631038026722 41.474999999999994 6.717368961973278 46.08333333333333 6.717368961973278C 50.69166666666666 6.717368961973278 54.64166666666666 103.57245632065775 59.24999999999999 103.57245632065775C 63.85833333333333 103.57245632065775 67.80833333333332 87.95066803699896 72.41666666666666 87.95066803699896C 77.02499999999999 87.95066803699896 80.975 97.32374100719424 85.58333333333333 97.32374100719424C 90.19166666666666 97.32374100719424 94.14166666666667 122.3186022610483 98.75 122.3186022610483C 103.35833333333333 122.3186022610483 107.30833333333334 64.51798561151078 111.91666666666667 64.51798561151078C 116.525 64.51798561151078 120.47500000000001 109.82117163412127 125.08333333333334 109.82117163412127C 129.69166666666666 109.82117163412127 133.64166666666668 55.144912641315514 138.25 55.144912641315514C 142.85833333333332 55.144912641315514 146.80833333333334 92.6372045220966 151.41666666666666 92.6372045220966C 156.02499999999998 92.6372045220966 159.975 80.13977389516957 164.58333333333331 80.13977389516957C 169.19166666666663 80.13977389516957 173.14166666666665 109.82117163412127 177.74999999999997 109.82117163412127C 182.3583333333333 109.82117163412127 186.3083333333333 72.32887975334017 190.91666666666663 72.32887975334017C 195.52499999999995 72.32887975334017 199.47499999999997 114.5077081192189 204.0833333333333 114.5077081192189C 208.6916666666666 114.5077081192189 212.64166666666662 94.19938335046248 217.24999999999994 94.19938335046248C 221.85833333333326 94.19938335046248 225.80833333333328 50.45837615621788 230.4166666666666 50.45837615621788C 235.02499999999992 50.45837615621788 238.97499999999994 67.64234326824254 243.58333333333326 67.64234326824254C 248.1916666666666 67.64234326824254 252.1416666666666 81.70195272353546 256.74999999999994 81.70195272353546C 261.3583333333333 81.70195272353546 265.3083333333333 67.64234326824254 269.91666666666663 67.64234326824254C 274.525 67.64234326824254 278.47499999999997 78.5775950668037 283.0833333333333 78.5775950668037C 287.69166666666666 78.5775950668037 291.64166666666665 56.70709146968139 296.25 56.70709146968139C 300.85833333333335 56.70709146968139 304.80833333333334 97.32374100719424 309.4166666666667 97.32374100719424"
                              pathFrom="M -1 152L -1 152L 19.75 152L 32.916666666666664 152L 46.08333333333333 152L 59.24999999999999 152L 72.41666666666666 152L 85.58333333333333 152L 98.75 152L 111.91666666666667 152L 125.08333333333334 152L 138.25 152L 151.41666666666666 152L 164.58333333333331 152L 177.74999999999997 152L 190.91666666666663 152L 204.0833333333333 152L 217.24999999999994 152L 230.4166666666666 152L 243.58333333333326 152L 256.74999999999994 152L 269.91666666666663 152L 283.0833333333333 152L 296.25 152L 309.4166666666667 152"
                            />
                            <path
                              id="apexcharts-area-0"
                              d="M6.583333333333333 152L6.583333333333333 91.07502569373072C11.191666666666666 91.07502569373072 15.141666666666666 69.20452209660843 19.75 69.20452209660843C24.358333333333334 69.20452209660843 28.30833333333333 84.82631038026722 32.916666666666664 84.82631038026722C37.525 84.82631038026722 41.474999999999994 6.717368961973278 46.08333333333333 6.717368961973278C50.69166666666666 6.717368961973278 54.64166666666666 103.57245632065775 59.24999999999999 103.57245632065775C63.85833333333333 103.57245632065775 67.80833333333332 87.95066803699896 72.41666666666666 87.95066803699896C77.02499999999999 87.95066803699896 80.975 97.32374100719424 85.58333333333333 97.32374100719424C90.19166666666666 97.32374100719424 94.14166666666667 122.3186022610483 98.75 122.3186022610483C103.35833333333333 122.3186022610483 107.30833333333334 64.51798561151078 111.91666666666667 64.51798561151078C116.525 64.51798561151078 120.47500000000001 109.82117163412127 125.08333333333334 109.82117163412127C129.69166666666666 109.82117163412127 133.64166666666668 55.144912641315514 138.25 55.144912641315514C142.85833333333332 55.144912641315514 146.80833333333334 92.6372045220966 151.41666666666666 92.6372045220966C156.02499999999998 92.6372045220966 159.975 80.13977389516957 164.58333333333331 80.13977389516957C169.19166666666663 80.13977389516957 173.14166666666665 109.82117163412127 177.74999999999997 109.82117163412127C182.3583333333333 109.82117163412127 186.3083333333333 72.32887975334017 190.91666666666663 72.32887975334017C195.52499999999995 72.32887975334017 199.47499999999997 114.5077081192189 204.0833333333333 114.5077081192189C208.6916666666666 114.5077081192189 212.64166666666662 94.19938335046248 217.24999999999994 94.19938335046248C221.85833333333326 94.19938335046248 225.80833333333328 50.45837615621788 230.4166666666666 50.45837615621788C235.02499999999992 50.45837615621788 238.97499999999994 67.64234326824254 243.58333333333326 67.64234326824254C248.1916666666666 67.64234326824254 252.1416666666666 81.70195272353546 256.74999999999994 81.70195272353546C261.3583333333333 81.70195272353546 265.3083333333333 67.64234326824254 269.91666666666663 67.64234326824254C274.525 67.64234326824254 278.47499999999997 78.5775950668037 283.0833333333333 78.5775950668037C287.69166666666666 78.5775950668037 291.64166666666665 56.70709146968139 296.25 56.70709146968139C300.85833333333335 56.70709146968139 304.80833333333334 97.32374100719424 309.4166666666667 97.32374100719424C309.4166666666667 97.32374100719424 309.4166666666667 97.32374100719424 309.4166666666667 152M309.4166666666667 97.32374100719424C309.4166666666667 97.32374100719424 309.4166666666667 97.32374100719424 309.4166666666667 97.32374100719424 "
                              fill="url(#SvgjsLinearGradient1052)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-area"
                              index="0"
                              clip-path="url(#gridRectMaskqhqchkth)"
                              pathTo="M 6.583333333333333 152L 6.583333333333333 91.07502569373072C 11.191666666666666 91.07502569373072 15.141666666666666 69.20452209660843 19.75 69.20452209660843C 24.358333333333334 69.20452209660843 28.30833333333333 84.82631038026722 32.916666666666664 84.82631038026722C 37.525 84.82631038026722 41.474999999999994 6.717368961973278 46.08333333333333 6.717368961973278C 50.69166666666666 6.717368961973278 54.64166666666666 103.57245632065775 59.24999999999999 103.57245632065775C 63.85833333333333 103.57245632065775 67.80833333333332 87.95066803699896 72.41666666666666 87.95066803699896C 77.02499999999999 87.95066803699896 80.975 97.32374100719424 85.58333333333333 97.32374100719424C 90.19166666666666 97.32374100719424 94.14166666666667 122.3186022610483 98.75 122.3186022610483C 103.35833333333333 122.3186022610483 107.30833333333334 64.51798561151078 111.91666666666667 64.51798561151078C 116.525 64.51798561151078 120.47500000000001 109.82117163412127 125.08333333333334 109.82117163412127C 129.69166666666666 109.82117163412127 133.64166666666668 55.144912641315514 138.25 55.144912641315514C 142.85833333333332 55.144912641315514 146.80833333333334 92.6372045220966 151.41666666666666 92.6372045220966C 156.02499999999998 92.6372045220966 159.975 80.13977389516957 164.58333333333331 80.13977389516957C 169.19166666666663 80.13977389516957 173.14166666666665 109.82117163412127 177.74999999999997 109.82117163412127C 182.3583333333333 109.82117163412127 186.3083333333333 72.32887975334017 190.91666666666663 72.32887975334017C 195.52499999999995 72.32887975334017 199.47499999999997 114.5077081192189 204.0833333333333 114.5077081192189C 208.6916666666666 114.5077081192189 212.64166666666662 94.19938335046248 217.24999999999994 94.19938335046248C 221.85833333333326 94.19938335046248 225.80833333333328 50.45837615621788 230.4166666666666 50.45837615621788C 235.02499999999992 50.45837615621788 238.97499999999994 67.64234326824254 243.58333333333326 67.64234326824254C 248.1916666666666 67.64234326824254 252.1416666666666 81.70195272353546 256.74999999999994 81.70195272353546C 261.3583333333333 81.70195272353546 265.3083333333333 67.64234326824254 269.91666666666663 67.64234326824254C 274.525 67.64234326824254 278.47499999999997 78.5775950668037 283.0833333333333 78.5775950668037C 287.69166666666666 78.5775950668037 291.64166666666665 56.70709146968139 296.25 56.70709146968139C 300.85833333333335 56.70709146968139 304.80833333333334 97.32374100719424 309.4166666666667 97.32374100719424C 309.4166666666667 97.32374100719424 309.4166666666667 97.32374100719424 309.4166666666667 152M 309.4166666666667 97.32374100719424z"
                              pathFrom="M -1 152L -1 152L 19.75 152L 32.916666666666664 152L 46.08333333333333 152L 59.24999999999999 152L 72.41666666666666 152L 85.58333333333333 152L 98.75 152L 111.91666666666667 152L 125.08333333333334 152L 138.25 152L 151.41666666666666 152L 164.58333333333331 152L 177.74999999999997 152L 190.91666666666663 152L 204.0833333333333 152L 217.24999999999994 152L 230.4166666666666 152L 243.58333333333326 152L 256.74999999999994 152L 269.91666666666663 152L 283.0833333333333 152L 296.25 152L 309.4166666666667 152"
                            />
                            <g id="SvgjsG1049" class="apexcharts-series-markers-wrap">
                              <g class="apexcharts-series-markers">
                                <circle
                                  id="SvgjsCircle1069"
                                  r="0"
                                  cx="0"
                                  cy="0"
                                  class="apexcharts-marker wy8egg3tf no-pointer-events"
                                  stroke="#ffffff"
                                  fill="#3ac47d"
                                  fill-opacity="1"
                                  stroke-width="2"
                                  stroke-opacity="0.9"
                                  default-marker-size="0"
                                />
                              </g>
                            </g>
                            <g id="SvgjsG1050" class="apexcharts-datalabels" />
                          </g>
                        </g>
                        <line
                          id="SvgjsLine1064"
                          x1="0"
                          y1="0"
                          x2="316"
                          y2="0"
                          stroke="#b6b6b6"
                          stroke-dasharray="0"
                          stroke-width="1"
                          class="apexcharts-ycrosshairs"
                        />
                        <line
                          id="SvgjsLine1065"
                          x1="0"
                          y1="0"
                          x2="316"
                          y2="0"
                          stroke-dasharray="0"
                          stroke-width="0"
                          class="apexcharts-ycrosshairs-hidden"
                        />
                        <g id="SvgjsG1066" class="apexcharts-yaxis-annotations" />
                        <g id="SvgjsG1067" class="apexcharts-xaxis-annotations" />
                        <g id="SvgjsG1068" class="apexcharts-point-annotations" />
                      </g>
                      <g
                        id="SvgjsG1059"
                        class="apexcharts-yaxis"
                        rel="0"
                        transform="translate(-35, 0)"
                      >
                        <g id="SvgjsG1060" class="apexcharts-yaxis-texts-g" />
                      </g>
                    </svg>
                    <div class="apexcharts-legend"></div>
                    <div class="apexcharts-tooltip light">
                      <div class="apexcharts-tooltip-series-group">
                        <span
                          class="apexcharts-tooltip-marker"
                          style="background-color: rgb(58, 196, 125);"
                        ></span>
                        <div class="apexcharts-tooltip-text">
                          <div class="apexcharts-tooltip-y-group">
                            <span class="apexcharts-tooltip-text-label"></span>
                            <span class="apexcharts-tooltip-text-value"></span>
                          </div>
                          <div class="apexcharts-tooltip-z-group">
                            <span class="apexcharts-tooltip-text-z-label"></span>
                            <span class="apexcharts-tooltip-text-z-value"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="resize-triggers">
                  <div class="expand-trigger">
                    <div style="width: 317px; height: 161px;"></div>
                  </div>
                  <div class="contract-trigger"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="pt-2 pb-0 card-body">
            <h6
              class="text-muted text-uppercase font-size-md opacity-9 mb-2 font-weight-normal"
            >Authors</h6>
            <div class="scroll-area-md shadow-overflow">
              <div class="scrollbar-container ps ps--active-y">
                <ul class="rm-list-borders rm-list-borders-scroll list-group list-group-flush">
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <img
                            width="38"
                            class="rounded-circle"
                            src="assets/images/avatars/1.jpg"
                            alt
                          />
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Viktor Martin</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$152</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            <span>752</span>
                            <small class="text-warning pl-2">
                              <i class="fa fa-angle-down"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <img
                            width="38"
                            class="rounded-circle"
                            src="assets/images/avatars/2.jpg"
                            alt
                          />
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Denis Delgado</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$53</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            <span>587</span>
                            <small class="text-danger pl-2">
                              <i class="fa fa-angle-up"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <img
                            width="38"
                            class="rounded-circle"
                            src="assets/images/avatars/3.jpg"
                            alt
                          />
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Shawn Galloway</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$239</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            <span>163</span>
                            <small class="text-muted pl-2">
                              <i class="fa fa-angle-down"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <img
                            width="38"
                            class="rounded-circle"
                            src="assets/images/avatars/4.jpg"
                            alt
                          />
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Latisha Allison</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$21</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            653
                            <small class="text-primary pl-2">
                              <i class="fa fa-angle-up"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <img
                            width="38"
                            class="rounded-circle"
                            src="assets/images/avatars/5.jpg"
                            alt
                          />
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Lilly-Mae White</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$381</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            629
                            <small class="text-muted pl-2">
                              <i class="fa fa-angle-up"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <img
                            width="38"
                            class="rounded-circle"
                            src="assets/images/avatars/8.jpg"
                            alt
                          />
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Julie Prosser</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$74</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            462
                            <small class="text-muted pl-2">
                              <i class="fa fa-angle-down"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="border-bottom-0 list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <img
                            width="38"
                            class="rounded-circle"
                            src="assets/images/avatars/8.jpg"
                            alt
                          />
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Amin Hamer</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$7</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            956
                            <small class="text-success pl-2">
                              <i class="fa fa-angle-up"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="ps__rail-x" style="left: 0px; bottom: 0px;">
                  <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
                </div>
                <div class="ps__rail-y" style="top: 0px; height: 300px; right: 0px;">
                  <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 206px;"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-block text-center rm-border card-footer">
            <button class="btn btn-primary">
              View complete report
              <span class="text-white pl-2 opacity-3">
                <i class="fa fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4">
        <div class="mb-3 card">
          <div class="card-header-tab card-header">
            <div class="card-header-title font-size-lg text-capitalize font-weight-normal">
              <i class="header-icon lnr-laptop-phone mr-3 text-muted opacity-6"></i>Best Selling Products
            </div>
            <div class="btn-actions-pane-right actions-icon-btn">
              <div class="btn-group dropdown">
                <button
                  data-toggle="dropdown"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  class="btn-icon btn-icon-only btn btn-link"
                >
                  <i class="pe-7s-menu btn-icon-wrapper"></i>
                </button>
                <div
                  tabindex="-1"
                  role="menu"
                  aria-hidden="true"
                  class="dropdown-menu-shadow dropdown-menu-hover-link dropdown-menu"
                >
                  <h6 tabindex="-1" class="dropdown-header">Header</h6>
                  <button type="button" tabindex="0" class="dropdown-item">
                    <i class="dropdown-icon lnr-inbox"></i>
                    <span>Menus</span>
                  </button>
                  <button type="button" tabindex="0" class="dropdown-item">
                    <i class="dropdown-icon lnr-file-empty"></i>
                    <span>Settings</span>
                  </button>
                  <button type="button" tabindex="0" class="dropdown-item">
                    <i class="dropdown-icon lnr-book"></i>
                    <span>Actions</span>
                  </button>
                  <div tabindex="-1" class="dropdown-divider"></div>
                  <div class="p-1 text-right">
                    <button class="mr-2 btn-shadow btn-sm btn btn-link">View Details</button>
                    <button class="mr-2 btn-shadow btn-sm btn btn-primary">Action</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="widget-chart widget-chart2 text-left p-0">
            <div class="widget-chat-wrapper-outer">
              <div class="widget-chart-content widget-chart-content-lg">
                <div class="widget-chart-flex">
                  <div class="widget-title opacity-5 text-muted text-uppercase">Toshiba Laptops</div>
                </div>
                <div class="widget-numbers">
                  <div class="widget-chart-flex">
                    <div>
                      <span class="opacity-10 text-warning pr-2">
                        <i class="fa fa-dot-circle"></i>
                      </span>
                      <span>$984</span>
                    </div>
                    <div class="widget-title ml-2 font-size-lg font-weight-normal text-muted">
                      <span class="text-success pl-2">+14</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="widget-chart-wrapper widget-chart-wrapper-xlg opacity-10 m-0">
                <div id="dashboard-sparkline-2" style="min-height: 152px;">
                  <div
                    id="apexchartsbtjxuzkj"
                    class="apexcharts-canvas apexchartsbtjxuzkj"
                    style="width: 316px; height: 152px;"
                  >
                    <svg
                      id="SvgjsSvg1006"
                      width="316"
                      height="152"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xmlns:svgjs="http://svgjs.com/svgjs"
                      class="apexcharts-svg"
                      xmlns:data="ApexChartsNS"
                      transform="translate(0, 0)"
                      style="background: transparent;"
                    >
                      <g
                        id="SvgjsG1008"
                        class="apexcharts-inner apexcharts-graphical"
                        transform="translate(0, 0)"
                      >
                        <defs id="SvgjsDefs1007">
                          <clipPath id="gridRectMaskbtjxuzkj">
                            <rect
                              id="SvgjsRect1012"
                              width="321"
                              height="157"
                              x="-2.5"
                              y="-2.5"
                              rx="0"
                              ry="0"
                              fill="#ffffff"
                              opacity="1"
                              stroke-width="0"
                              stroke="none"
                              stroke-dasharray="0"
                            />
                          </clipPath>
                          <clipPath id="gridRectMarkerMaskbtjxuzkj">
                            <rect
                              id="SvgjsRect1013"
                              width="330"
                              height="166"
                              x="-7"
                              y="-7"
                              rx="0"
                              ry="0"
                              fill="#ffffff"
                              opacity="1"
                              stroke-width="0"
                              stroke="none"
                              stroke-dasharray="0"
                            />
                          </clipPath>
                          <linearGradient id="SvgjsLinearGradient1020" x1="0" y1="0" x2="0" y2="1">
                            <stop
                              id="SvgjsStop1021"
                              stop-opacity="0.7"
                              stop-color="rgba(247,185,36,0.7)"
                              offset="0"
                            />
                            <stop
                              id="SvgjsStop1022"
                              stop-opacity="0.9"
                              stop-color="rgba(255,255,255,0.9)"
                              offset="0.9"
                            />
                            <stop
                              id="SvgjsStop1023"
                              stop-opacity="0.9"
                              stop-color="rgba(255,255,255,0.9)"
                              offset="1"
                            />
                          </linearGradient>
                        </defs>
                        <rect
                          id="SvgjsRect1011"
                          width="1"
                          height="152"
                          x="19.25"
                          y="0"
                          rx="0"
                          ry="0"
                          fill="#b1b9c4"
                          opacity="1"
                          stroke-width="0"
                          stroke-dasharray="0"
                          class="apexcharts-xcrosshairs"
                          filter="none"
                          fill-opacity="0.9"
                        />
                        <g id="SvgjsG1025" class="apexcharts-xaxis" transform="translate(0, 0)">
                          <g
                            id="SvgjsG1026"
                            class="apexcharts-xaxis-texts-g"
                            transform="translate(0, 1.875)"
                          />
                        </g>
                        <g id="SvgjsG1029" class="apexcharts-grid">
                          <line
                            id="SvgjsLine1031"
                            x1="0"
                            y1="152"
                            x2="316"
                            y2="152"
                            stroke="transparent"
                            stroke-dasharray="0"
                          />
                          <line
                            id="SvgjsLine1030"
                            x1="0"
                            y1="1"
                            x2="0"
                            y2="152"
                            stroke="transparent"
                            stroke-dasharray="0"
                          />
                        </g>
                        <g id="SvgjsG1015" class="apexcharts-area-series apexcharts-plot-series">
                          <g
                            id="SvgjsG1016"
                            class="apexcharts-series series-1"
                            data-:longest-series="true"
                            rel="1"
                            data-:real-index="0"
                          >
                            <path
                              id="apexcharts-area-0"
                              d="M6.583333333333333 80.13977389516957C11.191666666666666 80.13977389516957 15.141666666666666 122.3186022610483 19.75 122.3186022610483C24.358333333333334 122.3186022610483 28.30833333333333 84.82631038026722 32.916666666666664 84.82631038026722C37.525 84.82631038026722 41.474999999999994 114.5077081192189 46.08333333333333 114.5077081192189C50.69166666666666 114.5077081192189 54.64166666666666 67.64234326824254 59.24999999999999 67.64234326824254C63.85833333333333 67.64234326824254 67.80833333333332 87.95066803699896 72.41666666666666 87.95066803699896C77.02499999999999 87.95066803699896 80.975 97.32374100719424 85.58333333333333 97.32374100719424C90.19166666666666 97.32374100719424 94.14166666666667 50.45837615621788 98.75 50.45837615621788C103.35833333333333 50.45837615621788 107.30833333333334 109.82117163412127 111.91666666666667 109.82117163412127C116.525 109.82117163412127 120.47500000000001 81.70195272353546 125.08333333333334 81.70195272353546C129.69166666666666 81.70195272353546 133.64166666666668 92.6372045220966 138.25 92.6372045220966C142.85833333333332 92.6372045220966 146.80833333333334 94.19938335046248 151.41666666666666 94.19938335046248C156.02499999999998 94.19938335046248 159.975 67.64234326824254 164.58333333333331 67.64234326824254C169.19166666666663 67.64234326824254 173.14166666666665 91.07502569373072 177.74999999999997 91.07502569373072C182.3583333333333 91.07502569373072 186.3083333333333 97.32374100719424 190.91666666666663 97.32374100719424C195.52499999999995 97.32374100719424 199.47499999999997 56.70709146968139 204.0833333333333 56.70709146968139C208.6916666666666 56.70709146968139 212.64166666666662 109.82117163412127 217.24999999999994 109.82117163412127C221.85833333333326 109.82117163412127 225.80833333333328 78.5775950668037 230.4166666666666 78.5775950668037C235.02499999999992 78.5775950668037 238.97499999999994 6.717368961973278 243.58333333333326 6.717368961973278C248.1916666666666 6.717368961973278 252.1416666666666 55.144912641315514 256.74999999999994 55.144912641315514C261.3583333333333 55.144912641315514 265.3083333333333 69.20452209660843 269.91666666666663 69.20452209660843C274.525 69.20452209660843 278.47499999999997 72.32887975334017 283.0833333333333 72.32887975334017C287.69166666666666 72.32887975334017 291.64166666666665 103.57245632065775 296.25 103.57245632065775C300.85833333333335 103.57245632065775 304.80833333333334 64.51798561151078 309.4166666666667 64.51798561151078C309.4166666666667 64.51798561151078 309.4166666666667 64.51798561151078 309.4166666666667 64.51798561151078 "
                              fill="none"
                              fill-opacity="1"
                              stroke="#f7b924"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="5"
                              stroke-dasharray="0"
                              class="apexcharts-area"
                              index="0"
                              clip-path="url(#gridRectMaskbtjxuzkj)"
                              pathTo="M 6.583333333333333 80.13977389516957C 11.191666666666666 80.13977389516957 15.141666666666666 122.3186022610483 19.75 122.3186022610483C 24.358333333333334 122.3186022610483 28.30833333333333 84.82631038026722 32.916666666666664 84.82631038026722C 37.525 84.82631038026722 41.474999999999994 114.5077081192189 46.08333333333333 114.5077081192189C 50.69166666666666 114.5077081192189 54.64166666666666 67.64234326824254 59.24999999999999 67.64234326824254C 63.85833333333333 67.64234326824254 67.80833333333332 87.95066803699896 72.41666666666666 87.95066803699896C 77.02499999999999 87.95066803699896 80.975 97.32374100719424 85.58333333333333 97.32374100719424C 90.19166666666666 97.32374100719424 94.14166666666667 50.45837615621788 98.75 50.45837615621788C 103.35833333333333 50.45837615621788 107.30833333333334 109.82117163412127 111.91666666666667 109.82117163412127C 116.525 109.82117163412127 120.47500000000001 81.70195272353546 125.08333333333334 81.70195272353546C 129.69166666666666 81.70195272353546 133.64166666666668 92.6372045220966 138.25 92.6372045220966C 142.85833333333332 92.6372045220966 146.80833333333334 94.19938335046248 151.41666666666666 94.19938335046248C 156.02499999999998 94.19938335046248 159.975 67.64234326824254 164.58333333333331 67.64234326824254C 169.19166666666663 67.64234326824254 173.14166666666665 91.07502569373072 177.74999999999997 91.07502569373072C 182.3583333333333 91.07502569373072 186.3083333333333 97.32374100719424 190.91666666666663 97.32374100719424C 195.52499999999995 97.32374100719424 199.47499999999997 56.70709146968139 204.0833333333333 56.70709146968139C 208.6916666666666 56.70709146968139 212.64166666666662 109.82117163412127 217.24999999999994 109.82117163412127C 221.85833333333326 109.82117163412127 225.80833333333328 78.5775950668037 230.4166666666666 78.5775950668037C 235.02499999999992 78.5775950668037 238.97499999999994 6.717368961973278 243.58333333333326 6.717368961973278C 248.1916666666666 6.717368961973278 252.1416666666666 55.144912641315514 256.74999999999994 55.144912641315514C 261.3583333333333 55.144912641315514 265.3083333333333 69.20452209660843 269.91666666666663 69.20452209660843C 274.525 69.20452209660843 278.47499999999997 72.32887975334017 283.0833333333333 72.32887975334017C 287.69166666666666 72.32887975334017 291.64166666666665 103.57245632065775 296.25 103.57245632065775C 300.85833333333335 103.57245632065775 304.80833333333334 64.51798561151078 309.4166666666667 64.51798561151078"
                              pathFrom="M -1 152L -1 152L 19.75 152L 32.916666666666664 152L 46.08333333333333 152L 59.24999999999999 152L 72.41666666666666 152L 85.58333333333333 152L 98.75 152L 111.91666666666667 152L 125.08333333333334 152L 138.25 152L 151.41666666666666 152L 164.58333333333331 152L 177.74999999999997 152L 190.91666666666663 152L 204.0833333333333 152L 217.24999999999994 152L 230.4166666666666 152L 243.58333333333326 152L 256.74999999999994 152L 269.91666666666663 152L 283.0833333333333 152L 296.25 152L 309.4166666666667 152"
                            />
                            <path
                              id="apexcharts-area-0"
                              d="M6.583333333333333 152L6.583333333333333 80.13977389516957C11.191666666666666 80.13977389516957 15.141666666666666 122.3186022610483 19.75 122.3186022610483C24.358333333333334 122.3186022610483 28.30833333333333 84.82631038026722 32.916666666666664 84.82631038026722C37.525 84.82631038026722 41.474999999999994 114.5077081192189 46.08333333333333 114.5077081192189C50.69166666666666 114.5077081192189 54.64166666666666 67.64234326824254 59.24999999999999 67.64234326824254C63.85833333333333 67.64234326824254 67.80833333333332 87.95066803699896 72.41666666666666 87.95066803699896C77.02499999999999 87.95066803699896 80.975 97.32374100719424 85.58333333333333 97.32374100719424C90.19166666666666 97.32374100719424 94.14166666666667 50.45837615621788 98.75 50.45837615621788C103.35833333333333 50.45837615621788 107.30833333333334 109.82117163412127 111.91666666666667 109.82117163412127C116.525 109.82117163412127 120.47500000000001 81.70195272353546 125.08333333333334 81.70195272353546C129.69166666666666 81.70195272353546 133.64166666666668 92.6372045220966 138.25 92.6372045220966C142.85833333333332 92.6372045220966 146.80833333333334 94.19938335046248 151.41666666666666 94.19938335046248C156.02499999999998 94.19938335046248 159.975 67.64234326824254 164.58333333333331 67.64234326824254C169.19166666666663 67.64234326824254 173.14166666666665 91.07502569373072 177.74999999999997 91.07502569373072C182.3583333333333 91.07502569373072 186.3083333333333 97.32374100719424 190.91666666666663 97.32374100719424C195.52499999999995 97.32374100719424 199.47499999999997 56.70709146968139 204.0833333333333 56.70709146968139C208.6916666666666 56.70709146968139 212.64166666666662 109.82117163412127 217.24999999999994 109.82117163412127C221.85833333333326 109.82117163412127 225.80833333333328 78.5775950668037 230.4166666666666 78.5775950668037C235.02499999999992 78.5775950668037 238.97499999999994 6.717368961973278 243.58333333333326 6.717368961973278C248.1916666666666 6.717368961973278 252.1416666666666 55.144912641315514 256.74999999999994 55.144912641315514C261.3583333333333 55.144912641315514 265.3083333333333 69.20452209660843 269.91666666666663 69.20452209660843C274.525 69.20452209660843 278.47499999999997 72.32887975334017 283.0833333333333 72.32887975334017C287.69166666666666 72.32887975334017 291.64166666666665 103.57245632065775 296.25 103.57245632065775C300.85833333333335 103.57245632065775 304.80833333333334 64.51798561151078 309.4166666666667 64.51798561151078C309.4166666666667 64.51798561151078 309.4166666666667 64.51798561151078 309.4166666666667 152M309.4166666666667 64.51798561151078C309.4166666666667 64.51798561151078 309.4166666666667 64.51798561151078 309.4166666666667 64.51798561151078 "
                              fill="url(#SvgjsLinearGradient1020)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-area"
                              index="0"
                              clip-path="url(#gridRectMaskbtjxuzkj)"
                              pathTo="M 6.583333333333333 152L 6.583333333333333 80.13977389516957C 11.191666666666666 80.13977389516957 15.141666666666666 122.3186022610483 19.75 122.3186022610483C 24.358333333333334 122.3186022610483 28.30833333333333 84.82631038026722 32.916666666666664 84.82631038026722C 37.525 84.82631038026722 41.474999999999994 114.5077081192189 46.08333333333333 114.5077081192189C 50.69166666666666 114.5077081192189 54.64166666666666 67.64234326824254 59.24999999999999 67.64234326824254C 63.85833333333333 67.64234326824254 67.80833333333332 87.95066803699896 72.41666666666666 87.95066803699896C 77.02499999999999 87.95066803699896 80.975 97.32374100719424 85.58333333333333 97.32374100719424C 90.19166666666666 97.32374100719424 94.14166666666667 50.45837615621788 98.75 50.45837615621788C 103.35833333333333 50.45837615621788 107.30833333333334 109.82117163412127 111.91666666666667 109.82117163412127C 116.525 109.82117163412127 120.47500000000001 81.70195272353546 125.08333333333334 81.70195272353546C 129.69166666666666 81.70195272353546 133.64166666666668 92.6372045220966 138.25 92.6372045220966C 142.85833333333332 92.6372045220966 146.80833333333334 94.19938335046248 151.41666666666666 94.19938335046248C 156.02499999999998 94.19938335046248 159.975 67.64234326824254 164.58333333333331 67.64234326824254C 169.19166666666663 67.64234326824254 173.14166666666665 91.07502569373072 177.74999999999997 91.07502569373072C 182.3583333333333 91.07502569373072 186.3083333333333 97.32374100719424 190.91666666666663 97.32374100719424C 195.52499999999995 97.32374100719424 199.47499999999997 56.70709146968139 204.0833333333333 56.70709146968139C 208.6916666666666 56.70709146968139 212.64166666666662 109.82117163412127 217.24999999999994 109.82117163412127C 221.85833333333326 109.82117163412127 225.80833333333328 78.5775950668037 230.4166666666666 78.5775950668037C 235.02499999999992 78.5775950668037 238.97499999999994 6.717368961973278 243.58333333333326 6.717368961973278C 248.1916666666666 6.717368961973278 252.1416666666666 55.144912641315514 256.74999999999994 55.144912641315514C 261.3583333333333 55.144912641315514 265.3083333333333 69.20452209660843 269.91666666666663 69.20452209660843C 274.525 69.20452209660843 278.47499999999997 72.32887975334017 283.0833333333333 72.32887975334017C 287.69166666666666 72.32887975334017 291.64166666666665 103.57245632065775 296.25 103.57245632065775C 300.85833333333335 103.57245632065775 304.80833333333334 64.51798561151078 309.4166666666667 64.51798561151078C 309.4166666666667 64.51798561151078 309.4166666666667 64.51798561151078 309.4166666666667 152M 309.4166666666667 64.51798561151078z"
                              pathFrom="M -1 152L -1 152L 19.75 152L 32.916666666666664 152L 46.08333333333333 152L 59.24999999999999 152L 72.41666666666666 152L 85.58333333333333 152L 98.75 152L 111.91666666666667 152L 125.08333333333334 152L 138.25 152L 151.41666666666666 152L 164.58333333333331 152L 177.74999999999997 152L 190.91666666666663 152L 204.0833333333333 152L 217.24999999999994 152L 230.4166666666666 152L 243.58333333333326 152L 256.74999999999994 152L 269.91666666666663 152L 283.0833333333333 152L 296.25 152L 309.4166666666667 152"
                            />
                            <g id="SvgjsG1017" class="apexcharts-series-markers-wrap">
                              <g class="apexcharts-series-markers">
                                <circle
                                  id="SvgjsCircle1037"
                                  r="0"
                                  cx="19.75"
                                  cy="122.3186022610483"
                                  class="apexcharts-marker wji88wjdv no-pointer-events"
                                  stroke="#ffffff"
                                  fill="#f7b924"
                                  fill-opacity="1"
                                  stroke-width="2"
                                  stroke-opacity="0.9"
                                  default-marker-size="0"
                                />
                              </g>
                            </g>
                            <g id="SvgjsG1018" class="apexcharts-datalabels" />
                          </g>
                        </g>
                        <line
                          id="SvgjsLine1032"
                          x1="0"
                          y1="0"
                          x2="316"
                          y2="0"
                          stroke="#b6b6b6"
                          stroke-dasharray="0"
                          stroke-width="1"
                          class="apexcharts-ycrosshairs"
                        />
                        <line
                          id="SvgjsLine1033"
                          x1="0"
                          y1="0"
                          x2="316"
                          y2="0"
                          stroke-dasharray="0"
                          stroke-width="0"
                          class="apexcharts-ycrosshairs-hidden"
                        />
                        <g id="SvgjsG1034" class="apexcharts-yaxis-annotations" />
                        <g id="SvgjsG1035" class="apexcharts-xaxis-annotations" />
                        <g id="SvgjsG1036" class="apexcharts-point-annotations" />
                      </g>
                      <g
                        id="SvgjsG1027"
                        class="apexcharts-yaxis"
                        rel="0"
                        transform="translate(-35, 0)"
                      >
                        <g id="SvgjsG1028" class="apexcharts-yaxis-texts-g" />
                      </g>
                    </svg>
                    <div class="apexcharts-legend"></div>
                    <div class="apexcharts-tooltip light" style="left: 30px; top: 114px;">
                      <div class="apexcharts-tooltip-series-group active" style="display: flex;">
                        <span
                          class="apexcharts-tooltip-marker"
                          style="background-color: rgb(247, 185, 36); display: none;"
                        ></span>
                        <div class="apexcharts-tooltip-text">
                          <div class="apexcharts-tooltip-y-group">
                            <span class="apexcharts-tooltip-text-label"></span>
                            <span class="apexcharts-tooltip-text-value">19</span>
                          </div>
                          <div class="apexcharts-tooltip-z-group">
                            <span class="apexcharts-tooltip-text-z-label"></span>
                            <span class="apexcharts-tooltip-text-z-value"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="resize-triggers">
                  <div class="expand-trigger">
                    <div style="width: 317px; height: 161px;"></div>
                  </div>
                  <div class="contract-trigger"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="pt-2 pb-0 card-body">
            <h6
              class="text-muted text-uppercase font-size-md opacity-9 mb-2 font-weight-normal"
            >Top Performing</h6>
            <div class="scroll-area-md shadow-overflow">
              <div class="scrollbar-container ps ps--active-y">
                <ul class="rm-list-borders rm-list-borders-scroll list-group list-group-flush">
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <div class="icon-wrapper m-0">
                            <div class="progress-circle-wrapper">
                              <div class="progress-circle-wrapper">
                                <div class="circle-progress circle-progress-gradient">
                                  <canvas width="52" height="52"></canvas>
                                  <small>
                                    <span>
                                      72%
                                      <span></span>
                                    </span>
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Asus Laptop</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$152</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            <span>752</span>
                            <small class="text-warning pl-2">
                              <i class="fa fa-angle-down"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <div class="icon-wrapper m-0">
                            <div class="progress-circle-wrapper">
                              <div class="progress-circle-wrapper">
                                <div class="circle-progress circle-progress-danger">
                                  <canvas width="52" height="52"></canvas>
                                  <small>
                                    <span>
                                      23%
                                      <span></span>
                                    </span>
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Dell Inspire</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$53</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            <span>587</span>
                            <small class="text-danger pl-2">
                              <i class="fa fa-angle-up"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <div class="icon-wrapper m-0">
                            <div class="progress-circle-wrapper">
                              <div class="progress-circle-wrapper">
                                <div class="circle-progress circle-progress-primary">
                                  <canvas width="52" height="52"></canvas>
                                  <small>
                                    <span>
                                      64%
                                      <span></span>
                                    </span>
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Lenovo IdeaPad</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$239</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            <span>163</span>
                            <small class="text-muted pl-2">
                              <i class="fa fa-angle-down"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <div class="icon-wrapper m-0">
                            <div class="progress-circle-wrapper">
                              <div class="progress-circle-wrapper">
                                <div class="circle-progress circle-progress-info">
                                  <canvas width="52" height="52"></canvas>
                                  <small>
                                    <span>
                                      69%
                                      <span></span>
                                    </span>
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Asus Vivobook</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$21</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            653
                            <small class="text-primary pl-2">
                              <i class="fa fa-angle-up"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <div class="icon-wrapper m-0">
                            <div class="progress-circle-wrapper">
                              <div class="progress-circle-wrapper">
                                <div class="circle-progress circle-progress-warning">
                                  <canvas width="52" height="52"></canvas>
                                  <small>
                                    <span>
                                      23%
                                      <span></span>
                                    </span>
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Apple Macbook</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$381</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            629
                            <small class="text-muted pl-2">
                              <i class="fa fa-angle-up"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <div class="icon-wrapper m-0">
                            <div class="progress-circle-wrapper">
                              <div class="progress-circle-wrapper">
                                <div class="circle-progress circle-progress-dark">
                                  <canvas width="52" height="52"></canvas>
                                  <small>
                                    <span>
                                      69%
                                      <span></span>
                                    </span>
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">HP Envy 13"</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$74</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            462
                            <small class="text-muted pl-2">
                              <i class="fa fa-angle-down"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="border-bottom-0 list-group-item">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left mr-3">
                          <div class="icon-wrapper m-0">
                            <div class="progress-circle-wrapper">
                              <div class="progress-circle-wrapper">
                                <div class="circle-progress circle-progress-alternate">
                                  <canvas width="52" height="52"></canvas>
                                  <small>
                                    <span>
                                      69%
                                      <span></span>
                                    </span>
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="widget-content-left">
                          <div class="widget-heading">Gaming Laptop HP</div>
                          <div class="widget-subheading mt-1 opacity-10">
                            <div class="badge badge-pill badge-dark">$7</div>
                          </div>
                        </div>
                        <div class="widget-content-right">
                          <div class="fsize-1 text-focus">
                            <small class="opacity-5 pr-1">$</small>
                            956
                            <small class="text-success pl-2">
                              <i class="fa fa-angle-up"></i>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="ps__rail-x" style="left: 0px; bottom: 0px;">
                  <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
                </div>
                <div class="ps__rail-y" style="top: 0px; height: 300px; right: 0px;">
                  <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 185px;"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-block text-center rm-border card-footer">
            <button class="btn btn-primary">
              View all participants
              <span class="text-white pl-2 opacity-3">
                <i class="fa fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-4">
        <div class="mb-3 card">
          <div class="rm-border pb-0 responsive-center card-header">
            <div>
              <h5 class="menu-header-title text-capitalize">Portfolio Performance</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-xl-12">
              <div class="no-shadow rm-border bg-transparent widget-chart text-left card">
                <div class="progress-circle-wrapper">
                  <div class="circle-progress circle-progress-gradient-lg">
                    <canvas width="64" height="64"></canvas>
                    <small>
                      <span>
                        64%
                        <span></span>
                      </span>
                    </small>
                  </div>
                </div>
                <div class="widget-chart-content">
                  <div class="widget-subheading">Capital Gains</div>
                  <div class="widget-numbers text-success">
                    <span>$563</span>
                  </div>
                  <div class="widget-description text-focus">
                    Increased by
                    <span class="text-warning pl-1">
                      <i class="fa fa-angle-up"></i>
                      <span class="pl-1">7.35%</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-12">
              <div class="card no-shadow rm-border bg-transparent widget-chart text-left mt-2">
                <div class="progress-circle-wrapper">
                  <div class="circle-progress circle-progress-gradient-alt-lg">
                    <canvas width="64" height="64"></canvas>
                    <small>
                      <span>
                        58%
                        <span></span>
                      </span>
                    </small>
                  </div>
                </div>
                <div class="widget-chart-content">
                  <div class="widget-subheading">Withdrawals</div>
                  <div class="widget-numbers text-danger">
                    <span>$194</span>
                  </div>
                  <div class="widget-description opacity-8 text-focus">
                    Down by
                    <span class="text-success pl-1 pr-1">
                      <i class="fa fa-angle-down"></i>
                      <span class="pl-1">21.8%</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mx-auto mt-3">
            <div role="group" class="btn-group-sm btn-group nav">
              <a
                class="btn-shadow pl-3 pr-3 active btn btn-primary"
                data-toggle="tab"
                href="#sales-tab-1"
              >Income</a>
              <a
                class="btn-shadow pr-3 pl-3 btn btn-primary"
                data-toggle="tab"
                href="#sales-tab-2"
              >Expenses</a>
            </div>
          </div>
          <div class="card-body">
            <div class="tab-content">
              <div class="tab-pane fade active show" id="sales-tab-1" style="position: relative;">
                <div class="text-center">
                  <h5 class="menu-header-title">Target Sales</h5>
                  <h6 class="menu-header-subtitle opacity-6">Total performance for this month</h6>
                </div>
                <div id="dashboard-sparklines-primary" style="min-height: 279px;">
                  <div
                    id="apexchartsvf93h37g"
                    class="apexcharts-canvas apexchartsvf93h37g"
                    style="width: 276px; height: 265px;"
                  >
                    <svg
                      id="SvgjsSvg1070"
                      width="276"
                      height="265"
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xmlns:svgjs="http://svgjs.com/svgjs"
                      class="apexcharts-svg"
                      xmlns:data="ApexChartsNS"
                      transform="translate(0, 0)"
                      style="background: transparent;"
                    >
                      <foreignObject x="0" y="0" width="276" height="265">
                        <div
                          class="apexcharts-legend center position-bottom"
                          xmlns="http://www.w3.org/1999/xhtml"
                          style="right: 0px; position: absolute; left: 0px; top: auto; bottom: 10px;"
                        >
                          <div
                            class="apexcharts-legend-series"
                            rel="1"
                            data-:collapsed="false"
                            style="margin: 0px 5px;"
                          >
                            <span
                              class="apexcharts-legend-marker"
                              rel="1"
                              data-:collapsed="false"
                              style="background: rgb(0, 123, 255); color: rgb(0, 123, 255); height: 12px; width: 12px; left: 0px; top: 0px; border-width: 0px; border-color: rgb(255, 255, 255); border-radius: 2px;"
                            />
                            <span
                              class="apexcharts-legend-text"
                              rel="1"
                              data-:collapsed="false"
                              style="color: rgb(55, 61, 63); font-family: Helvetica, Arial, sans-serif;"
                            >Marine</span>
                          </div>
                          <div
                            class="apexcharts-legend-series"
                            rel="2"
                            data-:collapsed="false"
                            style="margin: 0px 5px;"
                          >
                            <span
                              class="apexcharts-legend-marker"
                              rel="2"
                              data-:collapsed="false"
                              style="background: rgb(22, 170, 255); color: rgb(22, 170, 255); height: 12px; width: 12px; left: 0px; top: 0px; border-width: 0px; border-color: rgb(255, 255, 255); border-radius: 2px;"
                            />
                            <span
                              class="apexcharts-legend-text"
                              rel="2"
                              data-:collapsed="false"
                              style="color: rgb(55, 61, 63); font-family: Helvetica, Arial, sans-serif;"
                            >Striking</span>
                          </div>
                        </div>
                      </foreignObject>
                      <g
                        id="SvgjsG1072"
                        class="apexcharts-inner apexcharts-graphical"
                        transform="translate(47.25, 40)"
                      >
                        <defs id="SvgjsDefs1071">
                          <linearGradient id="SvgjsLinearGradient1075" x1="0" y1="0" x2="0" y2="1">
                            <stop
                              id="SvgjsStop1076"
                              stop-opacity="0.4"
                              stop-color="rgba(216,227,240,0.4)"
                              offset="0"
                            />
                            <stop
                              id="SvgjsStop1077"
                              stop-opacity="0.5"
                              stop-color="rgba(190,209,230,0.5)"
                              offset="1"
                            />
                            <stop
                              id="SvgjsStop1078"
                              stop-opacity="0.5"
                              stop-color="rgba(190,209,230,0.5)"
                              offset="1"
                            />
                          </linearGradient>
                          <clipPath id="gridRectMaskvf93h37g">
                            <rect
                              id="SvgjsRect1080"
                              width="218.75"
                              height="161.348"
                              x="0"
                              y="0"
                              rx="0"
                              ry="0"
                              fill="#ffffff"
                              opacity="1"
                              stroke-width="0"
                              stroke="none"
                              stroke-dasharray="0"
                            />
                          </clipPath>
                          <clipPath id="gridRectMarkerMaskvf93h37g">
                            <rect
                              id="SvgjsRect1081"
                              width="226.75"
                              height="169.348"
                              x="-4"
                              y="-4"
                              rx="0"
                              ry="0"
                              fill="#ffffff"
                              opacity="1"
                              stroke-width="0"
                              stroke="none"
                              stroke-dasharray="0"
                            />
                          </clipPath>
                        </defs>
                        <rect
                          id="SvgjsRect1079"
                          width="12.760416666666668"
                          height="161.348"
                          x="0"
                          y="0"
                          rx="0"
                          ry="0"
                          fill="url(#SvgjsLinearGradient1075)"
                          opacity="1"
                          stroke-width="0"
                          stroke-dasharray="0"
                          class="apexcharts-xcrosshairs"
                          filter="none"
                          fill-opacity="0.9"
                        />
                        <g id="SvgjsG1112" class="apexcharts-xaxis" transform="translate(0, 0)">
                          <g
                            id="SvgjsG1113"
                            class="apexcharts-xaxis-texts-g"
                            transform="translate(0, -4)"
                          >
                            <text
                              id="SvgjsText1114"
                              font-family="Helvetica, Arial, sans-serif"
                              x="18.229166666666668"
                              y="190.348"
                              text-anchor="middle"
                              dominate-baseline="central"
                              font-size="12px"
                              fill="#373d3f"
                              class="apexcharts-xaxis-label apexcharts-xaxis-label"
                              style="font-family: Helvetica, Arial, sans-serif;"
                            >
                              <tspan
                                id="SvgjsTspan1115"
                                style="font-family: Helvetica, Arial, sans-serif;"
                              >1</tspan>
                              <title>1</title>
                            </text>
                            <text
                              id="SvgjsText1116"
                              font-family="Helvetica, Arial, sans-serif"
                              x="54.6875"
                              y="190.348"
                              text-anchor="middle"
                              dominate-baseline="central"
                              font-size="12px"
                              fill="#373d3f"
                              class="apexcharts-xaxis-label apexcharts-xaxis-label"
                              style="font-family: Helvetica, Arial, sans-serif;"
                            >
                              <tspan
                                id="SvgjsTspan1117"
                                style="font-family: Helvetica, Arial, sans-serif;"
                              >2</tspan>
                              <title>2</title>
                            </text>
                            <text
                              id="SvgjsText1118"
                              font-family="Helvetica, Arial, sans-serif"
                              x="91.14583333333333"
                              y="190.348"
                              text-anchor="middle"
                              dominate-baseline="central"
                              font-size="12px"
                              fill="#373d3f"
                              class="apexcharts-xaxis-label apexcharts-xaxis-label"
                              style="font-family: Helvetica, Arial, sans-serif;"
                            >
                              <tspan
                                id="SvgjsTspan1119"
                                style="font-family: Helvetica, Arial, sans-serif;"
                              >3</tspan>
                              <title>3</title>
                            </text>
                            <text
                              id="SvgjsText1120"
                              font-family="Helvetica, Arial, sans-serif"
                              x="127.60416666666667"
                              y="190.348"
                              text-anchor="middle"
                              dominate-baseline="central"
                              font-size="12px"
                              fill="#373d3f"
                              class="apexcharts-xaxis-label apexcharts-xaxis-label"
                              style="font-family: Helvetica, Arial, sans-serif;"
                            >
                              <tspan
                                id="SvgjsTspan1121"
                                style="font-family: Helvetica, Arial, sans-serif;"
                              >4</tspan>
                              <title>4</title>
                            </text>
                            <text
                              id="SvgjsText1122"
                              font-family="Helvetica, Arial, sans-serif"
                              x="164.06250000000003"
                              y="190.348"
                              text-anchor="middle"
                              dominate-baseline="central"
                              font-size="12px"
                              fill="#373d3f"
                              class="apexcharts-xaxis-label apexcharts-xaxis-label"
                              style="font-family: Helvetica, Arial, sans-serif;"
                            >
                              <tspan
                                id="SvgjsTspan1123"
                                style="font-family: Helvetica, Arial, sans-serif;"
                              >5</tspan>
                              <title>5</title>
                            </text>
                            <text
                              id="SvgjsText1124"
                              font-family="Helvetica, Arial, sans-serif"
                              x="200.52083333333337"
                              y="190.348"
                              text-anchor="middle"
                              dominate-baseline="central"
                              font-size="12px"
                              fill="#373d3f"
                              class="apexcharts-xaxis-label apexcharts-xaxis-label"
                              style="font-family: Helvetica, Arial, sans-serif;"
                            >
                              <tspan
                                id="SvgjsTspan1125"
                                style="font-family: Helvetica, Arial, sans-serif;"
                              >6</tspan>
                              <title>6</title>
                            </text>
                          </g>
                          <line
                            id="SvgjsLine1126"
                            x1="0"
                            y1="162.348"
                            x2="218.75"
                            y2="162.348"
                            stroke="#78909c"
                            stroke-dasharray="0"
                            stroke-width="1"
                          />
                        </g>
                        <g id="SvgjsG1136" class="apexcharts-grid">
                          <line
                            id="SvgjsLine1137"
                            x1="36.458333333333336"
                            y1="162.348"
                            x2="36.458333333333336"
                            y2="168.348"
                            stroke="#78909c"
                            stroke-dasharray="0"
                            class="apexcharts-xaxis-tick"
                          />
                          <line
                            id="SvgjsLine1138"
                            x1="72.91666666666667"
                            y1="162.348"
                            x2="72.91666666666667"
                            y2="168.348"
                            stroke="#78909c"
                            stroke-dasharray="0"
                            class="apexcharts-xaxis-tick"
                          />
                          <line
                            id="SvgjsLine1139"
                            x1="109.375"
                            y1="162.348"
                            x2="109.375"
                            y2="168.348"
                            stroke="#78909c"
                            stroke-dasharray="0"
                            class="apexcharts-xaxis-tick"
                          />
                          <line
                            id="SvgjsLine1140"
                            x1="145.83333333333334"
                            y1="162.348"
                            x2="145.83333333333334"
                            y2="168.348"
                            stroke="#78909c"
                            stroke-dasharray="0"
                            class="apexcharts-xaxis-tick"
                          />
                          <line
                            id="SvgjsLine1141"
                            x1="182.29166666666669"
                            y1="162.348"
                            x2="182.29166666666669"
                            y2="168.348"
                            stroke="#78909c"
                            stroke-dasharray="0"
                            class="apexcharts-xaxis-tick"
                          />
                          <line
                            id="SvgjsLine1142"
                            x1="0"
                            y1="0"
                            x2="218.75"
                            y2="0"
                            stroke="#e0e0e0"
                            stroke-dasharray="0"
                            class="apexcharts-gridline"
                          />
                          <line
                            id="SvgjsLine1143"
                            x1="0"
                            y1="26.891333333333336"
                            x2="218.75"
                            y2="26.891333333333336"
                            stroke="#e0e0e0"
                            stroke-dasharray="0"
                            class="apexcharts-gridline"
                          />
                          <line
                            id="SvgjsLine1144"
                            x1="0"
                            y1="53.78266666666667"
                            x2="218.75"
                            y2="53.78266666666667"
                            stroke="#e0e0e0"
                            stroke-dasharray="0"
                            class="apexcharts-gridline"
                          />
                          <line
                            id="SvgjsLine1145"
                            x1="0"
                            y1="80.674"
                            x2="218.75"
                            y2="80.674"
                            stroke="#e0e0e0"
                            stroke-dasharray="0"
                            class="apexcharts-gridline"
                          />
                          <line
                            id="SvgjsLine1146"
                            x1="0"
                            y1="107.56533333333334"
                            x2="218.75"
                            y2="107.56533333333334"
                            stroke="#e0e0e0"
                            stroke-dasharray="0"
                            class="apexcharts-gridline"
                          />
                          <line
                            id="SvgjsLine1147"
                            x1="0"
                            y1="134.45666666666668"
                            x2="218.75"
                            y2="134.45666666666668"
                            stroke="#e0e0e0"
                            stroke-dasharray="0"
                            class="apexcharts-gridline"
                          />
                          <line
                            id="SvgjsLine1148"
                            x1="0"
                            y1="161.348"
                            x2="218.75"
                            y2="161.348"
                            stroke="#e0e0e0"
                            stroke-dasharray="0"
                            class="apexcharts-gridline"
                          />
                          <line
                            id="SvgjsLine1150"
                            x1="0"
                            y1="161.348"
                            x2="218.75"
                            y2="161.348"
                            stroke="transparent"
                            stroke-dasharray="0"
                          />
                          <line
                            id="SvgjsLine1149"
                            x1="0"
                            y1="1"
                            x2="0"
                            y2="161.348"
                            stroke="transparent"
                            stroke-dasharray="0"
                          />
                        </g>
                        <g
                          id="SvgjsG1083"
                          class="apexcharts-bar-series apexcharts-plot-series"
                          clip-path="url(#gridRectMaskvf93h37g)"
                        >
                          <g
                            id="SvgjsG1084"
                            class="apexcharts-series Marine"
                            rel="1"
                            data-:real-index="0"
                          >
                            <path
                              id="apexcharts-bar-area-0"
                              d="M5.46875 161.348L5.46875 43.026133333333334L18.229166666666668 43.026133333333334L18.229166666666668 161.348L5.46875 161.348 "
                              fill="rgba(0,123,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="0"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 5.46875 161.348L 5.46875 43.026133333333334L 18.229166666666668 43.026133333333334L 18.229166666666668 161.348L 5.46875 161.348"
                              pathFrom="M 5.46875 161.348L 5.46875 161.348L 18.229166666666668 161.348L 18.229166666666668 161.348L 5.46875 161.348"
                              cy="43.026133333333334"
                              cx="41.927083333333336"
                              j="0"
                              val="44"
                              barWidth="12.760416666666668"
                            />
                            <path
                              id="apexcharts-bar-area-0"
                              d="M41.927083333333336 161.348L41.927083333333336 13.445666666666654L54.6875 13.445666666666654L54.6875 161.348L41.927083333333336 161.348 "
                              fill="rgba(0,123,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="0"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 41.927083333333336 161.348L 41.927083333333336 13.445666666666654L 54.6875 13.445666666666654L 54.6875 161.348L 41.927083333333336 161.348"
                              pathFrom="M 41.927083333333336 161.348L 41.927083333333336 161.348L 54.6875 161.348L 54.6875 161.348L 41.927083333333336 161.348"
                              cy="13.445666666666654"
                              cx="78.38541666666667"
                              j="1"
                              val="55"
                              barWidth="12.760416666666668"
                            />
                            <path
                              id="apexcharts-bar-area-0"
                              d="M78.38541666666667 161.348L78.38541666666667 51.09353333333334L91.14583333333334 51.09353333333334L91.14583333333334 161.348L78.38541666666667 161.348 "
                              fill="rgba(0,123,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="0"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 78.38541666666667 161.348L 78.38541666666667 51.09353333333334L 91.14583333333334 51.09353333333334L 91.14583333333334 161.348L 78.38541666666667 161.348"
                              pathFrom="M 78.38541666666667 161.348L 78.38541666666667 161.348L 91.14583333333334 161.348L 91.14583333333334 161.348L 78.38541666666667 161.348"
                              cy="51.09353333333334"
                              cx="114.84375"
                              j="2"
                              val="41"
                              barWidth="12.760416666666668"
                            />
                            <path
                              id="apexcharts-bar-area-0"
                              d="M114.84375 161.348L114.84375 61.85006666666666L127.60416666666667 61.85006666666666L127.60416666666667 161.348L114.84375 161.348 "
                              fill="rgba(0,123,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="0"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 114.84375 161.348L 114.84375 61.85006666666666L 127.60416666666667 61.85006666666666L 127.60416666666667 161.348L 114.84375 161.348"
                              pathFrom="M 114.84375 161.348L 114.84375 161.348L 127.60416666666667 161.348L 127.60416666666667 161.348L 114.84375 161.348"
                              cy="61.85006666666666"
                              cx="151.30208333333334"
                              j="3"
                              val="37"
                              barWidth="12.760416666666668"
                            />
                            <path
                              id="apexcharts-bar-area-0"
                              d="M151.30208333333334 161.348L151.30208333333334 102.18706666666668L164.0625 102.18706666666668L164.0625 161.348L151.30208333333334 161.348 "
                              fill="rgba(0,123,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="0"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 151.30208333333334 161.348L 151.30208333333334 102.18706666666668L 164.0625 102.18706666666668L 164.0625 161.348L 151.30208333333334 161.348"
                              pathFrom="M 151.30208333333334 161.348L 151.30208333333334 161.348L 164.0625 161.348L 164.0625 161.348L 151.30208333333334 161.348"
                              cy="102.18706666666668"
                              cx="187.76041666666669"
                              j="4"
                              val="22"
                              barWidth="12.760416666666668"
                            />
                            <path
                              id="apexcharts-bar-area-0"
                              d="M187.76041666666669 161.348L187.76041666666669 45.715266666666665L200.52083333333334 45.715266666666665L200.52083333333334 161.348L187.76041666666669 161.348 "
                              fill="rgba(0,123,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="0"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 187.76041666666669 161.348L 187.76041666666669 45.715266666666665L 200.52083333333334 45.715266666666665L 200.52083333333334 161.348L 187.76041666666669 161.348"
                              pathFrom="M 187.76041666666669 161.348L 187.76041666666669 161.348L 200.52083333333334 161.348L 200.52083333333334 161.348L 187.76041666666669 161.348"
                              cy="45.715266666666665"
                              cx="224.21875000000003"
                              j="5"
                              val="43"
                              barWidth="12.760416666666668"
                            />
                            <g id="SvgjsG1085" class="apexcharts-datalabels" />
                          </g>
                          <g
                            id="SvgjsG1098"
                            class="apexcharts-series Striking"
                            rel="2"
                            data-:real-index="1"
                          >
                            <path
                              id="apexcharts-bar-area-1"
                              d="M18.229166666666668 161.348L18.229166666666668 18.823933333333343L30.989583333333336 18.823933333333343L30.989583333333336 161.348L18.229166666666668 161.348 "
                              fill="rgba(22,170,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="1"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 18.229166666666668 161.348L 18.229166666666668 18.823933333333343L 30.989583333333336 18.823933333333343L 30.989583333333336 161.348L 18.229166666666668 161.348"
                              pathFrom="M 18.229166666666668 161.348L 18.229166666666668 161.348L 30.989583333333336 161.348L 30.989583333333336 161.348L 18.229166666666668 161.348"
                              cy="18.823933333333343"
                              cx="54.6875"
                              j="0"
                              val="53"
                              barWidth="12.760416666666668"
                            />
                            <path
                              id="apexcharts-bar-area-1"
                              d="M54.6875 161.348L54.6875 75.29573333333333L67.44791666666667 75.29573333333333L67.44791666666667 161.348L54.6875 161.348 "
                              fill="rgba(22,170,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="1"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 54.6875 161.348L 54.6875 75.29573333333333L 67.44791666666667 75.29573333333333L 67.44791666666667 161.348L 54.6875 161.348"
                              pathFrom="M 54.6875 161.348L 54.6875 161.348L 67.44791666666667 161.348L 67.44791666666667 161.348L 54.6875 161.348"
                              cy="75.29573333333333"
                              cx="91.14583333333334"
                              j="1"
                              val="32"
                              barWidth="12.760416666666668"
                            />
                            <path
                              id="apexcharts-bar-area-1"
                              d="M91.14583333333334 161.348L91.14583333333334 72.6066L103.90625000000001 72.6066L103.90625000000001 161.348L91.14583333333334 161.348 "
                              fill="rgba(22,170,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="1"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 91.14583333333334 161.348L 91.14583333333334 72.6066L 103.90625000000001 72.6066L 103.90625000000001 161.348L 91.14583333333334 161.348"
                              pathFrom="M 91.14583333333334 161.348L 91.14583333333334 161.348L 103.90625000000001 161.348L 103.90625000000001 161.348L 91.14583333333334 161.348"
                              cy="72.6066"
                              cx="127.60416666666667"
                              j="2"
                              val="33"
                              barWidth="12.760416666666668"
                            />
                            <path
                              id="apexcharts-bar-area-1"
                              d="M127.60416666666667 161.348L127.60416666666667 21.513066666666674L140.36458333333334 21.513066666666674L140.36458333333334 161.348L127.60416666666667 161.348 "
                              fill="rgba(22,170,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="1"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 127.60416666666667 161.348L 127.60416666666667 21.513066666666674L 140.36458333333334 21.513066666666674L 140.36458333333334 161.348L 127.60416666666667 161.348"
                              pathFrom="M 127.60416666666667 161.348L 127.60416666666667 161.348L 140.36458333333334 161.348L 140.36458333333334 161.348L 127.60416666666667 161.348"
                              cy="21.513066666666674"
                              cx="164.0625"
                              j="3"
                              val="52"
                              barWidth="12.760416666666668"
                            />
                            <path
                              id="apexcharts-bar-area-1"
                              d="M164.0625 161.348L164.0625 126.38926666666669L176.82291666666666 126.38926666666669L176.82291666666666 161.348L164.0625 161.348 "
                              fill="rgba(22,170,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="1"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 164.0625 161.348L 164.0625 126.38926666666669L 176.82291666666666 126.38926666666669L 176.82291666666666 161.348L 164.0625 161.348"
                              pathFrom="M 164.0625 161.348L 164.0625 161.348L 176.82291666666666 161.348L 176.82291666666666 161.348L 164.0625 161.348"
                              cy="126.38926666666669"
                              cx="200.52083333333334"
                              j="4"
                              val="13"
                              barWidth="12.760416666666668"
                            />
                            <path
                              id="apexcharts-bar-area-1"
                              d="M200.52083333333334 161.348L200.52083333333334 45.715266666666665L213.28125 45.715266666666665L213.28125 161.348L200.52083333333334 161.348 "
                              fill="rgba(22,170,255,0.8)"
                              fill-opacity="1"
                              stroke-opacity="1"
                              stroke-linecap="butt"
                              stroke-width="0"
                              stroke-dasharray="0"
                              class="apexcharts-bar-area"
                              index="1"
                              clip-path="url(#gridRectMaskvf93h37g)"
                              pathTo="M 200.52083333333334 161.348L 200.52083333333334 45.715266666666665L 213.28125 45.715266666666665L 213.28125 161.348L 200.52083333333334 161.348"
                              pathFrom="M 200.52083333333334 161.348L 200.52083333333334 161.348L 213.28125 161.348L 213.28125 161.348L 200.52083333333334 161.348"
                              cy="45.715266666666665"
                              cx="236.97916666666669"
                              j="5"
                              val="43"
                              barWidth="12.760416666666668"
                            />
                            <g id="SvgjsG1099" class="apexcharts-datalabels" />
                          </g>
                        </g>
                        <line
                          id="SvgjsLine1151"
                          x1="0"
                          y1="0"
                          x2="218.75"
                          y2="0"
                          stroke="#b6b6b6"
                          stroke-dasharray="0"
                          stroke-width="1"
                          class="apexcharts-ycrosshairs"
                        />
                        <line
                          id="SvgjsLine1152"
                          x1="0"
                          y1="0"
                          x2="218.75"
                          y2="0"
                          stroke-dasharray="0"
                          stroke-width="0"
                          class="apexcharts-ycrosshairs-hidden"
                        />
                        <g id="SvgjsG1153" class="apexcharts-yaxis-annotations" />
                        <g id="SvgjsG1154" class="apexcharts-xaxis-annotations" />
                        <g id="SvgjsG1155" class="apexcharts-point-annotations" />
                      </g>
                      <g
                        id="SvgjsG1127"
                        class="apexcharts-yaxis"
                        rel="0"
                        transform="translate(2.25, 0)"
                      >
                        <g id="SvgjsG1128" class="apexcharts-yaxis-texts-g">
                          <text
                            id="SvgjsText1129"
                            font-family="Helvetica, Arial, sans-serif"
                            x="20"
                            y="41.6"
                            text-anchor="end"
                            dominate-baseline="central"
                            font-size="11px"
                            fill="#373d3f"
                            class="apexcharts-yaxis-label apexcharts-yaxis-label"
                            style="font-family: Helvetica, Arial, sans-serif;"
                          >60</text>
                          <text
                            id="SvgjsText1130"
                            font-family="Helvetica, Arial, sans-serif"
                            x="20"
                            y="68.59133333333332"
                            text-anchor="end"
                            dominate-baseline="central"
                            font-size="11px"
                            fill="#373d3f"
                            class="apexcharts-yaxis-label apexcharts-yaxis-label"
                            style="font-family: Helvetica, Arial, sans-serif;"
                          >50</text>
                          <text
                            id="SvgjsText1131"
                            font-family="Helvetica, Arial, sans-serif"
                            x="20"
                            y="95.58266666666665"
                            text-anchor="end"
                            dominate-baseline="central"
                            font-size="11px"
                            fill="#373d3f"
                            class="apexcharts-yaxis-label apexcharts-yaxis-label"
                            style="font-family: Helvetica, Arial, sans-serif;"
                          >40</text>
                          <text
                            id="SvgjsText1132"
                            font-family="Helvetica, Arial, sans-serif"
                            x="20"
                            y="122.57399999999998"
                            text-anchor="end"
                            dominate-baseline="central"
                            font-size="11px"
                            fill="#373d3f"
                            class="apexcharts-yaxis-label apexcharts-yaxis-label"
                            style="font-family: Helvetica, Arial, sans-serif;"
                          >30</text>
                          <text
                            id="SvgjsText1133"
                            font-family="Helvetica, Arial, sans-serif"
                            x="20"
                            y="149.5653333333333"
                            text-anchor="end"
                            dominate-baseline="central"
                            font-size="11px"
                            fill="#373d3f"
                            class="apexcharts-yaxis-label apexcharts-yaxis-label"
                            style="font-family: Helvetica, Arial, sans-serif;"
                          >20</text>
                          <text
                            id="SvgjsText1134"
                            font-family="Helvetica, Arial, sans-serif"
                            x="20"
                            y="176.55666666666664"
                            text-anchor="end"
                            dominate-baseline="central"
                            font-size="11px"
                            fill="#373d3f"
                            class="apexcharts-yaxis-label apexcharts-yaxis-label"
                            style="font-family: Helvetica, Arial, sans-serif;"
                          >10</text>
                          <text
                            id="SvgjsText1135"
                            font-family="Helvetica, Arial, sans-serif"
                            x="20"
                            y="203.54799999999997"
                            text-anchor="end"
                            dominate-baseline="central"
                            font-size="11px"
                            fill="#373d3f"
                            class="apexcharts-yaxis-label apexcharts-yaxis-label"
                            style="font-family: Helvetica, Arial, sans-serif;"
                          >0</text>
                        </g>
                      </g>
                    </svg>
                    <div class="apexcharts-tooltip light">
                      <div class="apexcharts-tooltip-title"></div>
                      <div class="apexcharts-tooltip-series-group">
                        <span
                          class="apexcharts-tooltip-marker"
                          style="background-color: rgb(0, 123, 255);"
                        ></span>
                        <div class="apexcharts-tooltip-text">
                          <div class="apexcharts-tooltip-y-group">
                            <span class="apexcharts-tooltip-text-label"></span>
                            <span class="apexcharts-tooltip-text-value"></span>
                          </div>
                          <div class="apexcharts-tooltip-z-group">
                            <span class="apexcharts-tooltip-text-z-label"></span>
                            <span class="apexcharts-tooltip-text-z-value"></span>
                          </div>
                        </div>
                      </div>
                      <div class="apexcharts-tooltip-series-group">
                        <span
                          class="apexcharts-tooltip-marker"
                          style="background-color: rgb(22, 170, 255);"
                        ></span>
                        <div class="apexcharts-tooltip-text">
                          <div class="apexcharts-tooltip-y-group">
                            <span class="apexcharts-tooltip-text-label"></span>
                            <span class="apexcharts-tooltip-text-value"></span>
                          </div>
                          <div class="apexcharts-tooltip-z-group">
                            <span class="apexcharts-tooltip-text-z-label"></span>
                            <span class="apexcharts-tooltip-text-z-value"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="resize-triggers">
                  <div class="expand-trigger">
                    <div style="width: 277px; height: 328px;"></div>
                  </div>
                  <div class="contract-trigger"></div>
                </div>
              </div>
              <div class="tab-pane fade" id="sales-tab-2">
                <div class="text-center">
                  <h5 class="menu-header-title">Tabbed Content</h5>
                  <h6
                    class="menu-header-subtitle opacity-6"
                  >Example of various options built with ArchitectUI</h6>
                </div>
                <div
                  class="card-hover-shadow-2x widget-chart widget-chart2 bg-premium-dark text-left mt-3 card"
                >
                  <div class="widget-chart-content text-white">
                    <div class="widget-chart-flex">
                      <div class="widget-title">Sales</div>
                      <div class="widget-subtitle opacity-7">Monthly Goals</div>
                    </div>
                    <div class="widget-chart-flex">
                      <div class="widget-numbers text-success">
                        <small>$</small>
                        <span>976</span>
                        <small class="opacity-8 pl-2">
                          <i class="fa fa-angle-up"></i>
                        </small>
                      </div>
                      <div class="widget-description ml-auto opacity-7">
                        <i class="fa fa-angle-up"></i>
                        <span class="pl-1">175%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center mt-3">
                  <button class="btn-pill btn-shadow btn-wide fsize-1 btn btn-success btn-lg">
                    <span class="mr-2 opacity-7">
                      <i class="icon icon-anim-pulse ion-ios-analytics-outline"></i>
                    </span>
                    <span class="mr-1">View Complete Report</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
export default {
  name: "Dashboard",
  data() {
    return {
      sparklinesBigPrimary: {
        chart: {
          height: 265,
          type: "bar",
          stacked: false,
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        colors: ["#007bff", "#16aaff"],
        stroke: {
          width: 0,
          colors: ["#fff"],
          curve: "smooth"
        },
        series: [
          {
            name: "Marine",
            data: [44, 55, 41, 37, 22, 43]
          },
          {
            name: "Striking",
            data: [53, 32, 33, 52, 13, 43]
          }
        ],
        tooltip: {
          y: {
            formatter: function(val) {
              return val + "K";
            }
          }
        },
        fill: {
          opacity: 0.8
        },

        legend: {
          position: "bottom",
          horizontalAlign: "center"
        }
      }
    };
  },
  mounted() {
    window.Apex = {
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 2
      }
    };
    new ApexCharts(
      document.querySelector("#dashboard-sparklines-primary"),
      this.sparklinesBigPrimary
    ).render();
  }
};
</script>

                        <style type="text/css">
.apexcharts-legend {
  display: flex;
  overflow: auto;
  padding: 0 10px;
}

.apexcharts-legend.position-bottom,
.apexcharts-legend.position-top {
  flex-wrap: wrap;
}
.apexcharts-legend.position-right,
.apexcharts-legend.position-left {
  flex-direction: column;
  bottom: 0;
}

.apexcharts-legend.position-bottom.left,
.apexcharts-legend.position-top.left,
.apexcharts-legend.position-right,
.apexcharts-legend.position-left {
  justify-content: flex-start;
}

.apexcharts-legend.position-bottom.center,
.apexcharts-legend.position-top.center {
  justify-content: center;
}

.apexcharts-legend.position-bottom.right,
.apexcharts-legend.position-top.right {
  justify-content: flex-end;
}

.apexcharts-legend-series {
  cursor: pointer;
}

.apexcharts-legend.position-bottom .apexcharts-legend-series,
.apexcharts-legend.position-top .apexcharts-legend-series {
  display: flex;
  align-items: center;
}

.apexcharts-legend-text {
  position: relative;
  font-size: 14px;
}

.apexcharts-legend-marker {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin-right: 3px;
}

.apexcharts-legend.right .apexcharts-legend-series,
.apexcharts-legend.left .apexcharts-legend-series {
  display: inline-block;
}

.apexcharts-legend-series.no-click {
  cursor: auto;
}

.apexcharts-legend .apexcharts-hidden-zero-series {
  display: none !important;
}

.inactive-legend {
  opacity: 0.45;
}
</style>